// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    BULK_ASSIGN_ALERT_TYPES_REQUEST,
} from 'Redux/actionTypes';

// Actions
import { bulkAssignAlertTypesResult } from 'Redux/actions';

// Helpers
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* updateAlertTypes({ payload }) {

    const { alertTypes, devicesModels } = payload?.data

    try {
        let mutations = [];

        devicesModels.forEach((item, index) => {
            mutations.push(
                `result${index}: updateDeviceModel(
                    id: "${item.id}",
                    alertTypeIds: [${alertTypes?.join(", ")}]
                ) {
                    id
                    name
                    deviceModelAlertTypes {
                        id
                        deviceModelId
                        alertTypeId
                        alertType {
                            id
                            name
                            code
                            parentId
                        }
                    }
                }`
            )
        });

        let mutation = `mutation{${mutations.join("")}}`;

        const data = yield call(
            clientMutation,
            mutation,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        if (data && data?.result0) yield put(bulkAssignAlertTypesResult({ response: data?.result0 }))
        else yield put(bulkAssignAlertTypesResult({ error: true }))

    } catch (exc) {
        yield put(bulkAssignAlertTypesResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/deviceModelsTab/.components/bulkAssignAlertTypes/redux/saga",
            "updateAlertTypes"
        )
    }
}

function* watchMethods() {
    yield takeEvery(BULK_ASSIGN_ALERT_TYPES_REQUEST, updateAlertTypes);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}